import React, { useEffect, useState } from "react";
import { USER_URL } from "../../constant/api"; // ✅ update your correct path

const AdminSubAdmin = () => {
  const [subAdmins, setSubAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // Modal states
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedSubAdmin, setSelectedSubAdmin] = useState(null);
  const [updating, setUpdating] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
    commission_percentage: "",
    address: "",
    location: "",
    designation: "",
  });

  const fetchSubAdmins = async () => {
    try {
      setLoading(true);
      setErrorMsg("");

      const res = await USER_URL.get("/accounts/admin/all-subadmin/");
      console.log("subadmins",res.data);

      if (res?.data?.status === "1") {
        setSubAdmins(res.data.data || []);
      } else {
        setSubAdmins([]);
        setErrorMsg(res?.data?.message || "Failed to fetch sub admins");
      }
    } catch (error) {
      console.log("Fetch Sub Admin Error:", error);
      setErrorMsg("Something went wrong while fetching sub admins");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubAdmins();
  }, []);

  // ✅ Open Edit Modal
  const handleOpenEdit = (admin) => {
    setSelectedSubAdmin(admin);

    // ⚠️ Your list API gives only:
    // id, name, email, mobile_number, commission_percentage, designation
    // So split name into first/last roughly.
    const nameParts = (admin?.name || "").trim().split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.slice(1).join(" ") || "";

    setFormData({
      first_name: firstName,
      last_name: lastName,
      email: admin?.email || "",
      password: "",
      confirm_password: "",
      commission_percentage: admin?.commission_percentage ?? "",
      address: "",
      location: "",
      designation: admin?.designation || "",
    });

    setIsEditOpen(true);
  };

  // ✅ Close modal
  const handleCloseEdit = () => {
    setIsEditOpen(false);
    setSelectedSubAdmin(null);
  };

  // ✅ Input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ✅ Submit update API
  const handleUpdateSubAdmin = async (e) => {
  e.preventDefault();

  if (!selectedSubAdmin?.id) return;

  // ✅ Build PATCH payload (send only what you want to update)
  const payload = {
    first_name: formData.first_name,
    last_name: formData.last_name,
    email: formData.email,
    commission_percentage: Number(formData.commission_percentage),
    address: formData.address,
    location: formData.location,
    designation: formData.designation,
  };

  // ✅ Only send password if user entered it
  if (formData.password || formData.confirm_password) {
    if (!formData.password || !formData.confirm_password) {
      alert("Both Password and Confirm Password are required.");
      return;
    }

    if (formData.password !== formData.confirm_password) {
      alert("Password and Confirm Password do not match.");
      return;
    }

    payload.password = formData.password;
    payload.confirm_password = formData.confirm_password;
  }

  try {
    setUpdating(true);

    const res = await USER_URL.patch(
      `/accounts/admin/update/subadmin/${selectedSubAdmin.id}/`,
      payload
    );

    if (res?.data?.status === 1) {
      // ✅ Update UI instantly
      setSubAdmins((prev) =>
        prev.map((item) =>
          item.id === selectedSubAdmin.id
            ? {
                ...item,
                name: `${payload.first_name} ${payload.last_name}`.trim(),
                email: payload.email,
                commission_percentage: payload.commission_percentage,
                designation: payload.designation,
              }
            : item
        )
      );

      handleCloseEdit();
    } else {
      alert(res?.data?.message || "Update failed");
    }
  } catch (error) {
    console.log("Update SubAdmin Error:", error);

    const backendMsg =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      "Something went wrong while updating";

    alert(backendMsg);
  } finally {
    setUpdating(false);
  }
};


  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-2xl font-bold mb-6 text-gray-800">Sub Admin List</h2>

      {loading && (
        <div className="text-center py-6 text-gray-600 font-medium">
          Loading sub admins...
        </div>
      )}

      {!loading && errorMsg && (
        <div className="text-center py-6 text-red-600 font-medium">
          {errorMsg}
        </div>
      )}

      {!loading && !errorMsg && subAdmins.length === 0 && (
        <div className="text-center py-6 text-gray-600 font-medium">
          No Sub Admins Found
        </div>
      )}

      {!loading && !errorMsg && subAdmins.length > 0 && (
        <div className="overflow-x-auto bg-white shadow-md rounded-lg">
          <table className="min-w-full leading-normal">
            <thead>
              <tr>
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Name
                </th>
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Email
                </th>
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Mobile Number
                </th>
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Commission %
                </th>
                {/* <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Designation
                </th> */}
                <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {subAdmins.map((admin) => (
                <tr key={admin.id} className="hover:bg-gray-50">
                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    <p className="text-gray-900 whitespace-nowrap">
                      {admin?.name || "-"}
                    </p>
                  </td>

                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    <p className="text-gray-900 whitespace-nowrap">
                      {admin?.email || "-"}
                    </p>
                  </td>

                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    <p className="text-gray-900 whitespace-nowrap">
                      {admin?.mobile_number || "-"}
                    </p>
                  </td>

                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    <p className="text-gray-900 whitespace-nowrap">
                      {admin?.commission_percentage ?? 0}%
                    </p>
                  </td>

                  {/* <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    <p className="text-gray-900 whitespace-nowrap">
                      {admin?.designation || "-"}
                    </p>
                  </td> */}

                  <td className="px-5 py-5 border-b border-gray-200 text-sm">
                    <button
                      onClick={() => handleOpenEdit(admin)}
                      className="px-4 py-2 rounded-lg bg-black text-white text-sm hover:bg-gray-800"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* ✅ Edit Modal */}
      {isEditOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg p-6 relative">
            <h3 className="text-xl font-bold mb-4 text-gray-800">
              Edit Sub Admin
            </h3>

            <form onSubmit={handleUpdateSubAdmin} className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium text-gray-600">
                    First Name
                  </label>
                  <input
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 mt-1 outline-none focus:ring-1 focus:ring-black"
                    required
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-600">
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 mt-1 outline-none focus:ring-1 focus:ring-black"
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium text-gray-600">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 mt-1 outline-none focus:ring-1 focus:ring-black"
                    required
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-600">
                    Commission %
                  </label>
                  <input
                    type="number"
                    name="commission_percentage"
                    value={formData.commission_percentage}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 mt-1 outline-none focus:ring-1 focus:ring-black"
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium text-gray-600">
                    Password
                  </label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 mt-1 outline-none focus:ring-1 focus:ring-black"
                    placeholder="Enter new password"
                    required
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-600">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    name="confirm_password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 mt-1 outline-none focus:ring-1 focus:ring-black"
                    placeholder="Confirm password"
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-medium text-gray-600">
                    Location
                  </label>
                  <input
                    type="text"
                    name="location"
                    value={formData.location}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 mt-1 outline-none focus:ring-1 focus:ring-black"
                  />
                </div>

                <div>
                  <label className="text-sm font-medium text-gray-600">
                    Designation
                  </label>
                  <input
                    type="text"
                    name="designation"
                    value={formData.designation}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 mt-1 outline-none focus:ring-1 focus:ring-black"
                  />
                </div>
              </div>

              <div>
                <label className="text-sm font-medium text-gray-600">
                  Address
                </label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="w-full border rounded-lg px-3 py-2 mt-1 outline-none focus:ring-1 focus:ring-black"
                />
              </div>

              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={handleCloseEdit}
                  className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100"
                  disabled={updating}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="px-4 py-2 rounded-lg bg-black text-white hover:bg-gray-800 disabled:opacity-50"
                  disabled={updating}
                >
                  {updating ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSubAdmin;


